/**
 * @file CartOverlayGroup.tsx
 * @description Группа «Подложка» «Вида корзины» (phase19.16, SB120 этап 4;
 * uiux-cart §4, db-design-sb120-stage4 §1.3): затемнение страницы под
 * корзиной 0–80 % — у панели и окна своё (↺ панель 70, окно 0), и цвет
 * подложки (роли-заливки или свой; ↺ #6a7282 — серая, как сейчас). У цвета
 * подложки нет текста — строки контраста под полем нет.
 */

import { DEFAULT_SITE_CART, SITE_FILL_ROLES, SITE_THEME_LIMITS } from "@chaiberi/shared";

import { FieldHint, SettingsGroup } from "../../ui/settings-groups";
import { ColorField } from "../../site-fields/ColorField";
import type { NumberPreset } from "../../site-fields/NumberPresets";
import { useCartLook } from "./cart-look-context";
import { CartFields } from "./CartFields";
import { CartNumberField } from "./CartNumberField";
import { groupHasWarning, overlaySummary, sameValue } from "../../../lib/site-view/cart-look";
import { FILL_ROLE_LABELS } from "../../../lib/site-view/surface-fill-labels";

const D = SITE_THEME_LIMITS.cart.dim;

const DIM_PRESETS: readonly NumberPreset[] = [
  { label: "Нет", value: 0 },
  { label: "30", value: 30 },
  { label: "50", value: 50 },
  { label: "70", value: 70 },
];

export function CartOverlayGroup() {
  const { cart, theme, warnings, change } = useCartLook();
  const drawer = cart.mode === "drawer";
  const dim = drawer ? cart.drawer.dim : cart.popover.dim;
  return (
    <SettingsGroup
      id="overlay"
      title="Подложка"
      hint="Чем закрыта страница, пока корзина открыта."
      summary={overlaySummary(cart)}
      status={groupHasWarning(warnings, "overlay") ? "warning" : undefined}
    >
      <CartFields>
        <CartNumberField
          label={drawer ? "Затемнение под панелью" : "Затемнение под окном"}
          path={drawer ? "cart.drawer.dim" : "cart.popover.dim"}
          value={dim}
          min={D.min}
          max={D.max}
          def={drawer ? D.drawer : D.popover}
          unit="%"
          presets={DIM_PRESETS}
          patch={(v) => (drawer ? { drawer: { ...cart.drawer, dim: v } } : { popover: { ...cart.popover, dim: v } })}
        />
        {drawer ? null : <FieldHint className="mt-0">На телефоне окно открывается панелью — затемнение как у панели: {cart.drawer.dim} %.</FieldHint>}
        <ColorField
          mode="fill"
          label="Цвет подложки"
          value={cart.overlayColor}
          roles={SITE_FILL_ROLES}
          labels={FILL_ROLE_LABELS}
          colors={theme.colors}
          contrast={false}
          inheritLabel="как было"
          onReset={sameValue(cart.overlayColor, DEFAULT_SITE_CART.overlayColor) ? undefined : () => change({ overlayColor: DEFAULT_SITE_CART.overlayColor })}
          onChange={(fill) => (fill ? change({ overlayColor: fill }) : undefined)}
        />
        {dim === 0 ? <FieldHint className="mt-0">Без затемнения цвет подложки не виден.</FieldHint> : null}
      </CartFields>
    </SettingsGroup>
  );
}
